import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ContractService } from '../../../_services';
import { ContractIfrsBase } from "./base/contract-ifrs.base";

@Component({
	selector: 'a-b-entry',
	template: require('./a-b-entry.component.html'),
	encapsulation: ViewEncapsulation.None
})
export class EntryComponent extends ContractIfrsBase implements OnInit {

	constructor(contractService: ContractService) {
		super(contractService);
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/ifrs/a-b-entry.component.ts